import React, { useContext } from "react";
import SplitView from "../SplitView";
import {
  Modal,
  ModalHeader,
  ModalBody,
  // ModalFooter,
} from "reactstrap";
import { DataContext } from "../../context/DataContext";
function PwDetailsModal(props) {
  const { getPasswordVault } = useContext(DataContext);
  return (
    <Modal
      isOpen={props.pwDetailsModal}
      toggle={props.pwDetailsModaltoggle}
      size="md"
      centered
    >
      <ModalHeader toggle={props.pwDetailsModaltoggle}>
        Password Details
      </ModalHeader>
      <ModalBody>
        <SplitView
          data={props.details}
          noButton={true}
          onCopypassword={(id) => getPasswordVault(id)}
        />
      </ModalBody>
      {/* <ModalFooter className="centerBtn"></ModalFooter> */}
    </Modal>
  );
}

export default PwDetailsModal;
